import { gsap } from "gsap";

export default class AccordionHandler {
	init(options = {}) {
		const { firstTabActive = false, oneAtATime = false } = options;
		const accordions = gsap.utils.toArray('[data-accordion="container"]');
		accordions.forEach((accordion, index) => {
			const trigger = accordion.querySelector('[data-accordion="trigger"]');
			const content = accordion.querySelector('[data-accordion="content"]');
			
			if (index === 0 && firstTabActive) {
				accordion.classList.add('is-active');
				accordion.style.height = `${trigger.offsetHeight + content.offsetHeight}px`;
			} else {
				accordion.style.height = `${trigger.offsetHeight}px`;
			}
			
			trigger.addEventListener('click', () => {
				const isActive = accordion.classList.contains('is-active');
				
				if (oneAtATime && !isActive) {
					// Close all other accordions
					accordions.forEach((otherAccordion) => {
						if (otherAccordion !== accordion && otherAccordion.classList.contains('is-active')) {
							const otherTrigger = otherAccordion.querySelector('[data-accordion="trigger"]');
							otherAccordion.classList.remove('is-active');
							gsap.to(otherAccordion, { height: otherTrigger.offsetHeight, duration: 0.5, ease: 'power4.out' });
						}
					});
				}
				
				accordion.classList.toggle('is-active');
				const targetHeight = isActive 
					? trigger.offsetHeight
					: trigger.offsetHeight + content.offsetHeight;
				gsap.to(accordion, { height: targetHeight, duration: 0.5, ease: 'power4.out' });
			});
		});
		function updateAccordionHeight(accordion) {
			const trigger = accordion.querySelector('[data-accordion="trigger"]');
			const content = accordion.querySelector('[data-accordion="content"]');
			const isActive = accordion.classList.contains('is-active');
			const targetHeight = isActive 
				? trigger.offsetHeight + content.scrollHeight
				: trigger.offsetHeight;
			gsap.set(accordion, { height: targetHeight });
		}
		window.addEventListener('resize', () => accordions.forEach(updateAccordionHeight));
	}
}